export enum FilterMode {
  HasIssues = 'has-issues',
  NoIssues = 'no-issues',
  CheckedIn = 'checked-in',
  NotCheckedIn = 'not-checked-in',
  Dropped = 'dropped',
  FormsMissing = 'forms-missing',
  FormsCompleted = 'forms-completed',
  TeamComplete = 'team-complete',
  TeamIncomplete = 'team-incomplete',
  RequireNetwork = 'require-network',
  NotRequireNetwork = 'not-require-network'
}
